import styles from "./HorizontalList.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var HorizontalList = function HorizontalList(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx("div", {
    className: styles.list,
    "data-e2e-name": "horizontal_list",
    children: children
  });
};